"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { GalleryRoutedPage } from './deskUi/GalleryRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function GallerySurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={GalleryRoutedPage} Loading={MsgDeskLoading} />
}
